/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlHighestErrorTier } from './ControlHighestErrorTier';
import {
    ControlHighestErrorTierFromJSON,
    ControlHighestErrorTierFromJSONTyped,
    ControlHighestErrorTierToJSON,
} from './ControlHighestErrorTier';

/**
 * 
 * @export
 * @interface ControlIntegrationHealthDetailsV2
 */
export interface ControlIntegrationHealthDetailsV2 {
    /**
     * 
     * @type {number}
     * @memberof ControlIntegrationHealthDetailsV2
     */
    errorCount: number;
    /**
     * 
     * @type {ControlHighestErrorTier}
     * @memberof ControlIntegrationHealthDetailsV2
     */
    highestErrorTier: ControlHighestErrorTier;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationHealthDetailsV2
     */
    lastCheckedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationHealthDetailsV2
     */
    lastStatusChangeAt: string;
    /**
     * 
     * @type {number}
     * @memberof ControlIntegrationHealthDetailsV2
     */
    warningCount: number;
}

/**
 * Check if a given object implements the ControlIntegrationHealthDetailsV2 interface.
 */
export function instanceOfControlIntegrationHealthDetailsV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "errorCount" in value;
    isInstance = isInstance && "highestErrorTier" in value;
    isInstance = isInstance && "lastCheckedAt" in value;
    isInstance = isInstance && "lastStatusChangeAt" in value;
    isInstance = isInstance && "warningCount" in value;

    return isInstance;
}

export function ControlIntegrationHealthDetailsV2FromJSON(json: any): ControlIntegrationHealthDetailsV2 {
    return ControlIntegrationHealthDetailsV2FromJSONTyped(json, false);
}

export function ControlIntegrationHealthDetailsV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationHealthDetailsV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorCount': json['errorCount'],
        'highestErrorTier': ControlHighestErrorTierFromJSON(json['highestErrorTier']),
        'lastCheckedAt': json['lastCheckedAt'],
        'lastStatusChangeAt': json['lastStatusChangeAt'],
        'warningCount': json['warningCount'],
    };
}

export function ControlIntegrationHealthDetailsV2ToJSON(value?: ControlIntegrationHealthDetailsV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorCount': value.errorCount,
        'highestErrorTier': ControlHighestErrorTierToJSON(value.highestErrorTier),
        'lastCheckedAt': value.lastCheckedAt,
        'lastStatusChangeAt': value.lastStatusChangeAt,
        'warningCount': value.warningCount,
    };
}

